module.exports = __webpack_public_path__ + "img/Photo_1__Third_Canal_993_13_1.2b4f449c.jpg";